import { createSelector } from "reselect";
import { QuestionsInitialState } from "@common/feature/questions/types/general";

export const showQuestionsSelector = createSelector(
  (state: { Questions: QuestionsInitialState }) => state.Questions.showQuestions,
  (showQuestions) => showQuestions
);
